import { Container } from 'components/Containers'
import { MbTab, MbTabs, MbText } from 'mintbase-ui'
import React, { useEffect, useState } from 'react'
import { MarketRelation } from 'types/indexer'
import ActiveAuctions from './components/ActiveAuctions'
import ActiveStores from './components/ActiveStores'
import LatestListings from './components/LatestListings'
import LatestStores from './components/LatestStores'
import {
  FilterOptions,
  MarketTabProps,
  TMarketTab,
} from './types/Marketplace.type'

type TMarketTabs = TMarketTab[]

const defaultTabs = ['listings', 'stores', 'auctions']

const MarketplaceLayout = ({
  activeTab,
  filter,
  page,
  // data served from SSR
  ssrData,
}: {
  activeTab: string
  filter: string
  page: string
  ssrData: MarketRelation[]
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [activeFilter, setActiveFilter] = useState(
    Object.values(FilterOptions).includes(filter as FilterOptions)
      ? filter
      : FilterOptions.NEWEST
  )

  const [currentPage, setCurrentPage] = useState(Number(page))

  const marketTabs: TMarketTabs = [
    {
      title: 'Latest Listings',
      component: (props: MarketTabProps) => (
        <LatestListings
          filter={props.filter}
          page={props.page}
          ssrData={ssrData}
        />
      ),
      active: true,
      filterOptions: {
        label: 'Order by',
        defaultOptionId: activeFilter as FilterOptions,
        options: [
          {
            id: FilterOptions.NEWEST,
            label: 'Newest',
          },
          {
            id: FilterOptions.CHEAPEST,
            label: 'Cheapest',
          },
          {
            id: FilterOptions.EXPENSIVE,
            label: 'Most expensive',
          },
          {
            id: FilterOptions.OLDEST,
            label: 'Oldest',
          },
        ],
      },
    },
    // {
    //   title: 'Active Stores',
    //   component: (props: MarketTabProps) => (
    //     <ActiveStores filter={props.filter} page={props.page} />
    //   ),
    //   filterOptions: null,
    // },
    {
      title: 'Latest Stores',
      active: true,
      component: (props: MarketTabProps) => (
        <LatestStores filter={props.filter} page={props.page} />
      ),
      filterOptions: null,
    },
    {
      title: 'Active Auctions',
      component: (props: MarketTabProps) => (
        <ActiveAuctions filter={props.filter} page={props.page} />
      ),
      filterOptions: {
        label: 'Order by',
        defaultOptionId: activeFilter as FilterOptions,
        options: [
          {
            id: FilterOptions.NEWEST,
            label: 'Newest',
          },
          {
            id: FilterOptions.CHEAPEST,
            label: 'Cheapest',
          },
          {
            id: FilterOptions.EXPENSIVE,
            label: 'Most expensive',
          },
          {
            id: FilterOptions.OLDEST,
            label: 'Oldest',
          },
        ],
      },
      active: false,
    },
  ]

  useEffect(() => {
    setActiveFilter(FilterOptions.NEWEST)
    setCurrentPage(0)
  }, [activeTabIndex])

  useEffect(() => {
    setActiveTabIndex(
      defaultTabs.indexOf(activeTab) < 0 ? 0 : defaultTabs.indexOf(activeTab)
    )
  }, [activeTab])

  return (
    <div className={'bg-gray-100 dark:bg-gray-900 h-full'}>
      <MbTabs
        activeIndex={activeTabIndex}
        onTabChange={(value) => setActiveTabIndex(value)}
        onOrderByChange={(filter) => setActiveFilter(filter as FilterOptions)}
        filterOptions={marketTabs[activeTabIndex].filterOptions}
      >
        {marketTabs.map((tab, index) => (
          <MbTab key={index} label={<span>{tab.title}</span>}>
            <Container>
              <div className={'my-24'}>
                <MbText className="h3-130 text-black dark:text-white">
                  {tab.title}
                </MbText>
                {tab.component({
                  filter: activeFilter as FilterOptions,
                  page: currentPage,
                })}
              </div>
            </Container>
          </MbTab>
        ))}
      </MbTabs>
    </div>
  )
}

export default MarketplaceLayout
